// extracted by mini-css-extract-plugin
export default {"description":"LoanStatusChangeButton_description__M7jJp","productName":"LoanStatusChangeButton_productName__MglGg"};